<template>
    <div class="instrument_index">
      <div class="p20">
        <div>
          <label class="label">旧密码：</label>
          <el-input
            class="ml5 search-input"
            v-model="old_password"
            type="password"
            clearable
            placeholder="请输入旧密码"></el-input>
        </div>
        <div class="mt10">
          <label class="label">新密码：</label>
          <el-input 
            class="ml5 search-input" 
            v-model="new_password" 
            type="password"
            clearable 
            placeholder="请输入新密码"></el-input>
        </div>
        <div class="mt10">
          <label class="label">确认密码：</label>
          <el-input 
            class="ml5 search-input" 
            v-model="confirm_password" 
            type="password"
            clearable 
            placeholder="请确认密码"></el-input>
        </div>
        
        <el-button class="mt20" type="primary" size="mini" @click="getPassword">确认</el-button>
      </div>
    </div>
</template>

<script>
import { userPwd } from '@/api.js' 
export default {
    name:'workloadQuery',
    components:{

    },
    data() {
        return {
          old_password:'',
          new_password: '',
          confirm_password: ''
        }
    },
    methods:{
      getPassword(){
        const {
          old_password,
          new_password,
          confirm_password
        } = this

        this.$request('post', userPwd, {
          old_password,
          new_password,
          confirm_password
        }).then((res) => {
            if(res){
                this.$message.success('修改成功')
                window.location.replace('/login')
            }
        })
      },
        
    }
}
</script>

<style lang="scss" scoped>
  .label {
    width: 100px;
    display: inline-block;
  }
</style>